import {Deserializable} from '../deserializable';
import {CalendarNewsFile} from './calendarnewsfile';
import {DonVi} from '../danhmuc/donvi';
export  class CalendarNews implements Deserializable
{
  public  id: number;
  public  weekID: number;
  public  ngay: string;
  public  thoiGian: string;
  public  tuNgay: Date;
  public  tuGio: string;
  public  denNgay: Date;
  public  denGio: string;
  public  noiDung: string;
  public  chuTri: string;
  public  diaDiem: string;
  public  ghiChu: string;
  public  beLongTo: number;
  public  caLog: string;
  public  trangThai: number;
  public  suDung: number;
  public  soLuotDoc: number;
  public  userRead: String;
  public  bgColor: String;
  public calendarNewsFiles: CalendarNewsFile[];
  public donViTao: DonVi;
  deserialize(input: any): this {
    Object.assign(this, input);
    this.donViTao = input.donViTao != null ? new DonVi().deserialize(input.donViTao): null;
    this.calendarNewsFiles = input.calendarNewsFiles!=null ?  input.calendarNewsFiles.map(calendarNewsFiles => new CalendarNewsFile().deserialize(calendarNewsFiles)) : [];
    return this;
  }
}
